import React from 'react';
import Truncate from 'react-truncate';

import type { ImmutableEntity, Langcodes } from '@uncinc/react-drupal-core/types';
import {
  Icon,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CoreLink } from '@uncinc/react-drupal-core';
import { NodeArticle } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface NodeArticleHighlightedProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeArticle>;
}

const NodeArticleHighlighted: React.FC<NodeArticleHighlightedProps>
  = ({ entity }) => {
    const { t } = useTranslation();
    const article = entity.toJS();
    const title = article.title[0].value;
    const language = useSelector<Immutable.Map<any, any>>((state) => state.getIn(['ui', 'language']));
    const articleLink = article.paths[language as Langcodes]
      ? article.paths[language as Langcodes] : article.paths.nl;

    return (
      <div className="NodeArticleHighlighted">
        <div className="NodeArticleHighlighted__content">
          <h3>
            <Truncate lines={3} ellipsis="...">
              {title}
            </Truncate>
          </h3>
          <div className="NodeArticleHighlighted__body">
            <Truncate lines={3}>
              <WysiwygField
                html={article.body[0]?.summary}
              />
            </Truncate>
            <div className="NodeArticleHighlighted__link">
              <CoreLink
                href={articleLink}
                className="link--text"
                aria-label={`${t('general.read_more')} ${title}`}
              >
                {t('general.read_more')}
                <Icon name="arrow_forward" />
              </CoreLink>
            </div>
          </div>
        </div>
        <div className="separator" />
      </div>
    );
  };

export default NodeArticleHighlighted;
